<template>
  <div class="vip-coupon-wrapper">
    <transition name="opacity">
      <div class="cover" v-if="alertState"></div>
    </transition>
    <transition name="opacity">
      <div v-if="alertState" class="coupon-wrapper">
        <!-- <img src="https://logo.wondercv.com/banners/Q9h8RDrZSBvkRUt.png" alt=""> -->
        <div class="close-icon-content" @click="closeDialog">
          <i class="iconfont iconclose"></i>
        </div>
        <div class="coupon-title">终身会员限时秒杀</div>
        <div class="vip-countdown-wrapper">
          倒计时&nbsp;&nbsp;&nbsp;
          <Countdown
            :start-time="purchaseRecordData && purchaseRecordData.order_time"
            :current-time="purchaseRecordData && purchaseRecordData.time_now"
            :duration="memberPopupData.duration"
            countdown-type="pink"
          ></Countdown>
        </div>
        <div class="coupon-item-container" v-for="(item, index) in couponData" :key="index">
          <div class="left-money-number">¥<span class="number">{{ item.money }}</span></div>
          <div class="right-info-content">
            <div class="info-title">{{ item.couponTitle }}</div>
            <div class="info-desc">{{ item.couponDesc }}</div>
          </div>
        </div>
        <div class="bottom-btn" @click="handleClickBottomBtn">
          <i class="iconfont iconhuaban"></i>
          <span>升级会员</span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Countdown from '../../../components/Countdown.vue';
import { BUY_IN } from '@/assets/js/const';
export default {
  props: {
    alertState: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      BUY_IN
    }
  },
  mounted() {},
  components: {
    Countdown
  },
  watch: {},
  computed: {
    ...mapState('me', ['purchaseRecordData', 'personInfo']),
    ...mapGetters('me', ['memberPopupData']),
    couponData() {
      return this.memberPopupData?.couponList || [];
    }
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    },
    handleClickBottomBtn() {
      this.closeDialog();
      this.$emit('handleClickPay')
    }
  }
}
</script>
<style scoped lang="scss">
.vip-coupon-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  .cover {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
  }
  .coupon-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-image: url('https://logo.wondercv.com/banners/ghZEEK7NY82suyS.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 331px;
    height: 378px;
    padding-top: 112px;
    box-sizing: border-box;
    .close-icon-content {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 50px;
      right: 0;
      width: 60px;
      height: 40px;
      z-index: 11;
      cursor: pointer;
      color: #fff;
    }
    .coupon-title {
      font-size: 20px;
      line-height: 22px;
      color: #fff;
      font-weight: 600;
      margin-bottom: 14px;
    }
    .vip-countdown-wrapper {
      display: flex;
      align-items: center;
      color: #fff;
      font-weight: 500;
      margin-bottom: 24px;
    }
    .coupon-item-container {
      display: flex;
      align-items: center;
      width: calc(100% - 48px);
      height: 90px;
      background-image: url('https://logo.wondercv.com/banners/j405yexuawYw60J.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      box-sizing: border-box;
      padding: 0 16px;
      .left-money-number {
        color: #FF6837;
        font-size: 16px;
        font-weight: 600;
        .number {
          font-size: 32px;
          letter-spacing: 1px;
        }
      }
      .right-info-content{
        margin-left: 44px;
        .info-title {
          font-size: 16px;
          color: #1D1F38;
          font-weight: 600;
          margin-bottom: 10px;
        }
        .info-desc {
          font-size: 12px;
          color: #1D1F38;
        }
      }
    }
    .bottom-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 180px;
      height: 40px;
      color: #FF6937;
      background-color: #fff;
      font-weight: 600;
      margin-top: 24px;
      border-radius: 29px;
      cursor: pointer;
      i {
        margin-right: 6px;
      }
    }
  }
}
</style>